// extracted by mini-css-extract-plugin
module.exports = {"person-photo":"b759d2","person-photo__main":"_5da407","person-photo__box":"_62fc68","person-photo__content":"_8e1ba4","person-photo__empty":"b4385c"};